import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { CoPartnerForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class CoPartnerNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Хамтрагч байгууллага'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <CoPartnerForm 
                    path="partners"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(CoPartnerNew)
